var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.191,
    height: 52.3,
    viewBox: "0 0 70.191 52.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.192 13.765H6a6.007 6.007 0 0 1-6-6V6a6.007 6.007 0 0 1 6-6h58.192a6.007 6.007 0 0 1 6 6v1.764a6.007 6.007 0 0 1-6 6.001zM53.676 4.819v4.816h11.01V4.819z",
    transform: "translate(-964 -531.999) translate(964 531.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.192 13.765H6a6.007 6.007 0 0 1-6-6V6a6.007 6.007 0 0 1 6-6h58.192a6.007 6.007 0 0 1 6 6v1.764a6.007 6.007 0 0 1-6 6.001zm-27.72-8.946v4.816h28.214V4.819z",
    transform: "translate(-964 -531.999) translate(964 551.266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.192 13.765H6a6.007 6.007 0 0 1-6-6V6a6.007 6.007 0 0 1 6-6h58.192a6.007 6.007 0 0 1 6 6v1.764a6.007 6.007 0 0 1-6 6.001zM50.235 4.819v4.816h14.45V4.819z",
    transform: "translate(-964 -531.999) translate(964 570.534)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsFilled);
export default __webpack_public_path__ + "static/media/reports-filled.deeafbe60aa3fb8ade40633c1e700419.svg";
export { ForwardRef as ReactComponent };